module.exports = __webpack_public_path__ + "asset/img/default.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/default.png
// module id = 708
// module chunks = 14 33 36 39